module.exports = __webpack_public_path__ + "static/img/7.e015e08.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/front/threeD/4/7.png
// module id = qnd0
// module chunks = 2